/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from '@material-ui/core';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import I18n from '../../components/Translate/I18n';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CustomInputExt from '../../components/CustomInput/CustomInputExt';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoOperationSetup from '../../interfaces/platform/MvnoOperatorSetup';
import { OperatorMvneTypeMap } from '../../modules/lib/hooks/useOperatorType';
import CustomInputExtNumber from '../../components/CustomInput/CustomInputExtNumber';

type ServiceProfileAddNewType = {
    open: boolean;
    closeCallback(): void;
    reloadCallback(): void;
};

export const ServiceProfileAddNew: FunctionComponent<ServiceProfileAddNewType> = ({ open, closeCallback, reloadCallback }): ReactElement => {
    const dispatch = useDispatch();
    const [displayName, setDisplayName] = useState('');
    const [prepaid, setPrepaid] = useState(false);
    const [constName, setConstName] = useState('');
    const [constValue, setConstValue] = useState('');
    const [typeValue, setTypeValue] = useState('TARIFF');
    const [operatorType, setOperatorType] = useState(OperatorMvneTypeMap.OPL);

    useEffect(() => {
        if (!open) {
            setDisplayName('');
            setPrepaid(false);
            setConstName('');
            setConstValue('');
        }
    }, [open]);

    const createTemplate = (): void => {
        const newTemplate = {
            typeValue: typeValue,
            constName: constName,
            constValue: constValue,
            displayName: displayName,
            prepaid: prepaid,
            operatorType: operatorType,
        } as MvnoOperationSetup;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_operator_setups')),
            'mvno_operator_setups_post',
            newTemplate,
            (data: MvnoOperationSetup): void => {
                reloadCallback();
                closeCallback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const checked = event.target.checked;
        const value = event.target.value;
        setPrepaid(checked);
    };

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        switch (field) {
            case 'displayName':
                setDisplayName(value);
                break;
            case 'constName':
                setConstName(value);
                break;
            case 'constValue':
                setConstValue(value);
                break;
            default:
                return;
        }
    };

    return (
        <Dialog open={open} maxWidth="md" fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <I18n trans="prov:profile.add_new" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <CustomInputExt
                            formControlProps={{ fullWidth: true }}
                            required={true}
                            labelText="prov:profile.name"
                            name="displayName"
                            value={displayName}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExt
                            formControlProps={{ fullWidth: true }}
                            required={true}
                            labelText="prov:profile.id_profile_string"
                            name="constName"
                            value={constName}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            formControlProps={{ fullWidth: true }}
                            required={true}
                            labelText="prov:profile.id_profile_number"
                            name="constValue"
                            value={constValue}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <FormControlLabel
                            control={<Checkbox checked={prepaid} name="prepaid" onChange={onCheckBoxEvent} value={1} />}
                            label={<I18n trans="prov:profile.is_prepaid" />}
                        />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closeCallback} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={createTemplate} callbackParam={{}} label="general:common.save" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
